import React, { Component } from 'react';
import { Form, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import TenantAdminPage from '../hocs/TenantAdminPage';
import { texts } from '../../config';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');

export default TenantAdminPage(class TenantAdminTags extends Component {
  constructor() {
    super();
    this.state = {
      newTag: ''
    };
  }
  componentDidMount() {
    this.listenTags();
  }
  listenTags() {
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('tags')
      .onSnapshot((snapshot) => {
        this.setState({ tags: snapshot.docs.map(_ => ({ ..._.data(), id: _.id })) });
      });
  }
  clear = () => {
    this.setState({ newTag: '' });
  }
  onSubmit = (event) => {
    event.preventDefault();
    const { tenant: { tags = [] }, match: { params: { slug } } } = this.props;
    const { newTag } = this.state;
    if (!newTag) return;
    tenantsRef
      .doc(slug)
      .collection('tags')
      .add({ name: newTag })
      .then(this.clear)
      .then(() => toast.success('追加しました'));
  }
  delete = (id) => {
    if (!window.confirm('本当に削除しますか？')) return;
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('tags')
      .doc(id)
      .delete()
      .then(() => toast.success('削除しました'));
  }
  onChangeTag = ({ target: { value } }) => {
    this.setState({ newTag: value });
  }
  render() {
    const { match: { params: { slug } } } = this.props;
    const { newTag, tags } = this.state;
    return (
      <div className="admin-tenants">
        <div className="d-flex justify-content-center mb-3">
          <h4>予約タグ設定</h4>
        </div>
        <Form className="d-flex justify-content-end" onSubmit={this.onSubmit}>
          <Input className="mr-2" style={{ width: '200px' }} value={newTag} onChange={this.onChangeTag} />
          <Button type="submit" color="primary" disabled={!newTag}>
            <span className="fas fa-plus mr-1" />
            追加
          </Button>
        </Form>
        <table className="table mt-5">
          <tbody>
            {
              (tags || []).map(({ name, id }) => {
                return (
                  <tr key={id}>
                    <td>
                      {name}
                    </td>
                    <td>
                      <Button color="danger" onClick={this.delete.bind(this, id)}>
                        <span className="fas fa-trash mr-1" />
                        削除
                      </Button>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
});
